import React, { useEffect, useState } from 'react'
import AppBar from '../components/app-bar'
import { Button, Box, AppBar as AppBarHistory, CircularProgress, Typography, TableContainer, makeStyles, Select, MenuItem, Divider, InputLabel, FormControl, Dialog, TextField, Tooltip, IconButton, Menu } from '@material-ui/core'
import { customTheme } from '../styling'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import AddIcon from '@mui/icons-material/Add';
import axiosInstance from '../axios'
import formatIcon from '../images/image/format-icon.svg'
import condividiSvg from '../images/condividi.svg'
import formatVerticalIcon from '../images/image/format-vertical.svg'
import formatHorizontalIcon from '../images/image/format-horizontal.svg'
import formatSquareIcon from '../images/image/format-square.svg'
import deleteIcon from '../images/delete-icon.svg'
import styleIcon from '../images/image/style-icon.svg'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import DownloadIcon from '@mui/icons-material/Download'
import moment from 'moment'
import { Buffer } from 'buffer'
import iconClean from '../images/icon-clean.svg'
import forbidden from '../images/403.jpg'
import { OPENAI_CUSTOMER } from '../utils'


const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },

  textarea: {
    fontSize: '1rem',
    border: '1px solid #000',
    // paddingLeft: '0.5rem',
    // paddingTop: '0.5rem',
    margin: 0,
    padding: 0,
    // backgroundColor:'green',
    border: 'none',
    borderColor: 'none',
    resize: 'none',
    width: '100%',
    borderRadius: 15,
    minHeight: '53vh',
    boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
    '&:focus': {
      outline: 'none !important',
      outlineColor: '#B91F26',
      border: '1px solid #ba1f26 !important'
    },
  },

  input: {
    position: 'relative',
    top: '0.5rem',
    marginLeft: '1rem',
  },
  formControl: {
    minWidth: 300, 
    marginRight: '1.5rem'
  },
}))

const styleOfImages = [
  {
    id: 1, text: 'Libero', value: 'Libero',
  },
  {
    id: 2, text: 'Quadrato a cornice', value: `Create a realistic, high-quality image with a professional finance theme. The image should depict a close-up of business activity in a modern office setting.  show some close-up people. Add [USER DESCRIPTION] as main central subject focus. Use a clean color palette with white, gray, and soft blue tones, complemented by natural light coming through. Keep the central subject in focus and avoid clutter. Blur and zoom in the image and give focus on the main elements on focus while maintaining a photorealistic finish and a polished corporate aesthetic. The composition should be tightly zoomed in, highlighting the central subject. The image must be blurred, not in high definition.`,
  },
  {
    id: 3, text: 'Realistico finance', value: 'Create a realistic, high-quality image with a classic finance theme. The image should depict a professional environment or financial activity, incorporating elements such as electronic devices, like smartphones, tablets, or laptops, graphs, charts, or financial data overlays in glowing or semi-transparent styles. Use a dark, elegant color scheme with accents of red, gray, and black for a professional aesthetic. Include blurred or abstract modern office surroundings or soft bokeh lighting for depth and atmosphere. Add [USER DESCRIPTION] to customize the scene. Maintain a sharp, photorealistic finish to emphasize professionalism and financial focus.',
  },
]


const formatImages = [
  {
    id: 1, text: 'Quadrato', value: 'quadrato', icon: formatSquareIcon
  },
  {
    id: 2, text: 'Verticale', value: 'verticale', icon: formatVerticalIcon
  },
  {
    id: 3, text: 'Orizzontale', value: 'orizzontale', icon: formatHorizontalIcon
  },
]

const sizeMapping = {
  'quadrato': '1024x1024',
  'verticale': '1024x1792',
  'orizzontale': '1792x1024'
}

const Images = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(null)
  const { enqueueSnackbar } = SnackBar.Consumer()
  const classes = useStyles()
  const [generating, setGenerating] = useState(false)
  const [saving, setSaving] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [styleOfImage, setStyleOfImage] = useState('')
  const [formatImage, setFormatImage] = useState('')
  const [textareaImage, setTextareaImage] = useState('')
  const [imageGenerated, setImageGenerated] = useState(null)
  const [savedImageModalOpen, setSavedImageModalOpen] = useState(false)
  const [savedImageName, setSavedImageName] = useState(null)
  const [zoomedImage, setZoomedImage] = useState(null)
  const [imagesArchiveModalOpen, setImagesArchiveModalOpen] = useState(false)
  const [imagesArchived, setImagesArchived] = useState([])
  const [userDetails, setUserDetails] = useState(null)
  const [savingImage, setSavingImage] = useState(false)
  const [deletingImage, setDeletingImage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showmenu, setshowmenu] = useState(null)
  const openMenuUser = Boolean(anchorEl);
  const [loadingGrant, setLoadingGrant] = useState([])
  
  const handleClose = () => {
    setAnchorEl(null);
    setshowmenu(null)
  };


  // Function to open zoomed image
  const openZoomedImage = () => {
    setZoomedImage(imageGenerated)
  };
  // Function to close zoomed image
  const closeZoomedImage = () => {
    setZoomedImage(null)
  }

  const handleGenerateImage = async () => {
    setImageGenerated(null)
    setGenerating(true)
    const body = {
      size: sizeMapping[formatImage],
      send: `[${textareaImage}]`,
      style: styleOfImage === 'Libero' ? textareaImage : styleOfImage.replace('[USER DESCRIPTION]', textareaImage),
      customer: OPENAI_CUSTOMER,
      user_id: userDetails?.id,
    }

    try {
      const imageGenerated = await axiosInstance.post(`${process.env.REACT_APP_API_DOMAIN}/aisolutions/image/`, body)
      setImageGenerated(imageGenerated?.data?.image)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setGenerating(false)
    }

  }

  const handleDownloadImage = async (image) => {

    setDownloading(true)
    const decodeData = Buffer.from(image, 'base64')
    let blob = new Blob([decodeData])
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = `image-${moment().format('YYYY-MM-DD HH:mm')}.jpg`
    link.click()

    setDownloading(false)
  }

  const handleDownloadImageUrl = async (filename, file_url) => {
    try {
      const response  = await axiosInstance.get(file_url, { responseType: 'blob' })
      const blob = new Blob([response.data])
      const downloadUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = downloadUrl
      link.download = filename + '.jpg'
      link.click()
      URL.revokeObjectURL(downloadUrl)

    } catch (error) {
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
      console.log('error', error)
    }
    
  }


  const handleSave = async () => {
    setSavingImage(true)
    const body = {
      "image": {
        "style": styleOfImage,
        "format": formatImage,
        "prompt": textareaImage,
        "filename": savedImageName,
        "data":imageGenerated,
        "content_type": "image/jpg"
      }
    }

    try {
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`, body)
      enqueueSnackbar({variant:'success', message:'Immagine salvata correttamente' })
    } catch (error) {
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE })
    }finally{
      setSavingImage(false)
      setSavedImageModalOpen(false)
    }
  }



  useEffect(() => {
    setLoading(true)
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`).then((res) => {
      setImagesArchived(res.data.payload.images)
      setLoading(false)
    }).finally(() => {
      setLoading(false)
    })
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`, {
    }).then((res) => {
      setUserDetails(res.data.payload)
    }).catch(error => {

    })

    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/users`, {
    }).then((res) => {
      setUsers(res.data.payload.users)
    }).catch(error => {

    })
  }, [])

  const handleDeleteArchive = async() => {
    setDeletingImage(true)
    try {
      const textTranslated = await axiosInstance.delete(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images/${openDeleteModal}`)
      enqueueSnackbar({variant:'success', message:'Traduzione eliminata correttamente'})
      setOpenDeleteModal(null)
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`).then((res) => {
        setImagesArchived(res.data.payload.images)
      })

    } catch (error) {
        enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
    }finally{
      setDeletingImage(false)
    }
    
  } 

  const handleRemoveGrant = async (id, email) => {
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images/${id}/revoke`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`)

      setImagesArchived(res.data.payload.images)
      
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  const handleAddGrant = async (id, email) => {
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images/${id}/grant`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`)

      setImagesArchived(res.data.payload.images)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }


  
  

  return (
    <AppBar>
       {(!userDetails?.enable_image_generator && !loading) ?  <Box id="coming-soon" style={{ 
          background: 'white',

           backgroundImage: `url(${forbidden})`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', width: '100%' }} /> :
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {loading ? <Box style={{ position:'absolute', top:'50%', left:'50%'}}><CircularProgress /></Box> :
        <>
        <Typography className={classes.title} style={{ float: 'left' }} variant="h5" gutterBottom component="h2">
          AI Images
        </Typography>

        {openDeleteModal &&
            <Dialog  onClose={() => setOpenDeleteModal(null)} open={openDeleteModal}>
              <Box style={{ width: '400px', height: '250px', padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                <Typography variant='h5'>Conferma richiesta</Typography>
                <Typography style={{marginTop:'1rem', fontSize:'0.9rem'}}>Vuoi davvero eliminare questo file?</Typography>
                <Typography style={{fontSize:'0.9rem'}}>Una volta eliminato, non sarà possibile recuperarlo.</Typography>
                <Box style={{ marginTop: '1.5rem' }}>
                <Button color='primary'  onClick={() => handleDeleteArchive()} variant='contained'>{deletingImage ? <CircularProgress color='secondary' size={22} /> : 'Elimina'}</Button>
                </Box>

              </Box>
            </Dialog>
          }
        
        <Box style={{ float: 'right' }}>
          <Box style={{ display: 'flex', flexDirection: 'row', }}>
            {imageGenerated &&
              <Box onClick={() => {
                setTextareaImage('')
                setImageGenerated(null)

              }} style={{ color: customTheme.colors.ui.red, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}><img style={{ position: 'relative', top: '0.3rem' }} src={iconClean} /> Pulisci</Box>
            }
            {imageGenerated &&
              <Box onClick={() => setSavedImageModalOpen(true)} style={{ color: customTheme.colors.ui.green, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}>Salva</Box>
            }
            <Box onClick={() => setImagesArchiveModalOpen(true)} style={{ textDecoration: 'underline', marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}>Archivio</Box>
          </Box>
        </Box>
        {savedImageModalOpen &&
          <Dialog open={savedImageModalOpen}>
            <Box style={{ width: '400px', height: '250px', padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <Typography variant='h5'>Salva immagine</Typography>
              <TextField helperText='Campo obbligatorio' style={{ marginTop: '1.5rem' }} placeholder='Nome del file' value={savedImageName} onChange={(event) => setSavedImageName(event.target.value)} />
              <Box style={{ marginTop: '1.5rem' }}>
                <Button style={{width:'7rem', marginRight: '1rem'}} onClick={() => setSavedImageModalOpen(false)} variant='contained'  >Annulla</Button>
                <Button style={{width:'7rem'}} disabled={!savedImageName} onClick={() => savedImageName && handleSave()} color='primary' variant='contained'  >{savingImage ? <CircularProgress color='secondary'  size={26} /> : 'Salva'}</Button>
              </Box>

            </Box>
          </Dialog>
        }
         {imagesArchiveModalOpen &&
            <AppBarHistory style={{ marginTop: '4rem', backgroundColor: 'white', width: '60vw', height: '100%' }}>
              <Box style={{ padding: '20px', cursor: 'pointer' }}>
                <Box style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
                  <ArrowForwardIosIcon onClick={() => setImagesArchiveModalOpen(false)} style={{ color: 'black' }} />
                  <Typography style={{ color: 'black', marginLeft: '1rem' }} variant='h6'>Archivio</Typography>
                </Box>
                <ul style={{ listStyleType: 'none', lineHeight: 2 }}>
                  {imagesArchived.map((imageArchived) => {
                  
                    
                    const userDetailsFormatted = imageArchived?.writable ? userDetails : imageArchived?.user
                    return <Box style={{
                      width: '100%',
                      backgroundColor: 'white',
                      padding: '1rem',
                      borderRadius: 15,
                      marginBottom: '1rem',
                      boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
                      color: 'black', fontSize: '1rem', display: 'grid',
                      gridTemplateColumns: '1.6fr 1.6fr 1.6fr 1.3fr',
                      gap: '1.5rem'
                    }} key={imageArchived.id}>
                      <Box><InsertDriveFileIcon style={{ color: 'grey', fontSize: '1.1rem', position: 'relative', top: '0.1rem', marginRight: '0.5rem' }} />{imageArchived.filename}</Box>
                      <Box style={{ fontSize: '0.9rem', textAlign: 'right' }}>{moment(imageArchived.created_at).format('dd MM YYYY hh:mm')}</Box>
                      <Box style={{ display: 'flex', flexDirection: 'row' }}><Box style={{
                        position: 'relative', top: '0.3rem',
                        fontSize: '0.8rem',
                        marginRight: '0.5rem',
                        // paddingTop:'0.2rem',
                        borderRadius: '50%', width: '22px', textAlign: 'center',
                        height: '22px', background: userDetailsFormatted?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'

                      }}>{userDetailsFormatted?.first_name.slice(0, 1)}</Box>{userDetailsFormatted?.first_name} {userDetailsFormatted?.last_name}</Box>
                      <Box style={{ textAlign: 'center' }}>{imageArchived.writable && <img 
        onClick={(event) => {
          setshowmenu(imageArchived.id)
          setAnchorEl(event.currentTarget)
        }}
         style={{ width: '1rem', marginRight: '0.8rem' }} src={condividiSvg} />}<DownloadIcon onClick={() => handleDownloadImageUrl(imageArchived.filename, imageArchived.file_url)} style={{ color: 'grey', fontSize: '1.2rem', position: 'relative', top: '0.2rem',  marginRight: '0.8rem',  }} />{imageArchived.writable && <img onClick={() => setOpenDeleteModal(imageArchived.id)} style={{ cursor:'pointer', width: '1rem', position: 'relative', top: '0.1rem'}} src={deleteIcon} />}</Box>
                    {showmenu === imageArchived.id && <Menu id="basic-menu"
        anchorEl={anchorEl}
        open={openMenuUser}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
                      {users.map(({id, first_name, last_name, email}) => {
                        return (first_name || last_name) && <MenuItem style={{display: 'block'}} key={id}> 
                         <Box style={{
                          float:'left',
              marginRight: '0.5rem',
              // paddingTop:'0.2rem',
              borderRadius: '50%', width: '24px', textAlign: 'center',
              height: '24px', background: email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'

            }}>{first_name.slice(0, 1)}</Box>
            <Typography id="basic-menu" style={{ marginRight: '0.5rem',float:'left', }}>
              {first_name} {last_name}</Typography> {loadingGrant.includes(email) ? <CircularProgress size={12} style={{float:'right'}} /> : imageArchived?.grantees?.find((grant) => email === grant.email) ? <img src={deleteIcon} onClick={() => handleRemoveGrant(imageArchived.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.red, float:'right'}}   /> : <AddIcon onClick={() => handleAddGrant(imageArchived.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.black, float:'right'}} />}
                        
                        </MenuItem>
                      })}
                      </Menu>
                  }
                    </Box>
                  })}
                </ul>

              </Box>
            </AppBarHistory>
          }
        <TableContainer>
          <Divider />


          <Box 
            style={{
              width: '100%', 
              display:'flex', 
              marginTop: '1rem', 
              display: 'grid', 
              gridTemplateColumns: '1fr 1fr',
              gap: '1rem',
              // backgroundColor:'yellow'
            }}>
            <Box 
              style={{
                
                // backgroundColor:'red',
                paddingBottom: 0,
              }}>

                <FormControl className={classes.formControl}>
                  <InputLabel onClick={(event) => handleClickStyleImage(event)} className={classes.input} id="demo-simple-select-label"><Box style={{ top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={styleIcon} />Stile immagine</Box></InputLabel>
                  <Select
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    label={
                      <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={formatIcon} />Stile immagine</Box>
                    }
                    variant='outlined'
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={styleOfImage}
                    onChange={(event) => { setStyleOfImage(event.target.value) }}
                  >
                    {styleOfImages.map(({ id, text, value }) => (
                      <MenuItem key={id} value={value}>
                        {text}
                      </MenuItem>
                    ))}
      
                  </Select>
                </FormControl>
                <FormControl className={classes.formControl}>
                  <InputLabel onClick={(event) => handleClickStyleImage(event)} className={classes.input} id="demo-simple-select-label"><Box style={{ top: '0.2rem', position: 'relative', color: (textareaImage && !formatImage) && customTheme.colors.ui.red }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem', }} src={formatIcon} />Formato</Box></InputLabel>
                  <Select
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    label={
                      <Box><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={formatIcon} />Formato</Box>
                    }
                    variant='outlined'
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formatImage}
                    onChange={(event) => { setFormatImage(event.target.value) }}
                  >
                    {(
                      styleOfImages.find(({ value }) => value === styleOfImage)?.id === 2
                        ? formatImages.slice(0, 1)
                        : formatImages
                    ).map(({ id, text, value, icon }) => (
                      <MenuItem key={id} value={value}>
                        <img src={icon} style={{ marginRight: '1rem', height: id === 2 ? '0.9rem' : undefined, width: '0.8rem' }} /> {text}
                      </MenuItem>
                    ))}
      
                  </Select>
      
      
      
      
                </FormControl>


              <Box style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                marginTop: '1rem',
                // backgroundColor:'blue',
                height: '53vh',
                paddingBottom: 0,
              }}>

                <Box style={{
                  gridRowStart: 1,
                  gridColumnStart: 1,
                  height: '100%',
                }}>

                  <textarea placeholder="Descrivi qui l’immagine che vuoi realizzare..." value={textareaImage} onChange={(e) => setTextareaImage(e.target.value)} className={classes.textarea} style={{ padding: '16px 18px' }} />
                </Box>


              </Box>


            </Box>
            
            <Box xs={6} style={{marginTop: '1.1rem'}}>
              <Box disabled={!imageGenerated} style={{ fontSize: '1rem', textAlign: 'center', width: '100%', height:'100%', borderRadius: 15, boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}` }}>
                {imageGenerated ?
                  <Box style={{ width: '100%', height: '100%' }}>
                    <img onClick={() => openZoomedImage()} style={{ objectFit: 'contain', width: '100%', height: '100%', cursor: 'zoom-in' }} src={`data:image/png;base64,${imageGenerated}`} />
                    {zoomedImage && (
                      <div className="zoomed-image-container" onClick={closeZoomedImage}>
                        <img style={{ position: 'fixed', top: 90, zIndex: 1000, objectFit: 'contain', width: formatImage === 'orizzontale' ? '60%' : '100%', height: '85%', cursor: 'zoom-out' }} src={`data:image/png;base64,${imageGenerated}`} />
                      </div>
                    )}

                  </Box>


                  : <Box style={{ display:'flex', textAlign: 'center', fontStyle: 'italic', color: '#b3b3b3ff', justifyContent:'center', alignItems:'center', height:'100%' }}>
                    L'immagine creata verrà mostrata qui
                  </Box>

                }
                {imageGenerated &&
                  <Tooltip style={{  }} title="Scarica l’immagine">

                      <DownloadIcon onClick={() => handleDownloadImage(imageGenerated)} style={{ float: 'right', position: 'relative', bottom: '1rem', cursor: 'pointer', fontSize: '1.3rem',color: 'grey',  }} />

                  </Tooltip>
                }



              </Box>


            </Box>
          </Box>


          <Box style={{ width: '100%', marginTop: '1.5rem', textAlign: 'center' }}>
            <Button color={'primary'} disabled={!textareaImage || !formatImage || !styleOfImage} style={{ width: '8rem' }} onClick={() => textareaImage && styleOfImage && formatImage && handleGenerateImage()} variant='contained'>{generating ? <CircularProgress size={22} color='secondary' /> : 'Genera'}</Button>
          </Box>
        </TableContainer>
        </>}
      </main>
}
    </AppBar>

  )
}

export default Images